import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Help16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M8.07555 5.20297C7.8752 5.18911 7.67484 5.23061 7.4965 5.3229C7.3181 5.41521 7.16849 5.55479 7.06406 5.72638C6.95964 5.89795 6.90439 6.09494 6.90435 6.2958C6.90428 6.63198 6.6317 6.90445 6.29553 6.90438C5.95936 6.90431 5.68689 6.63173 5.68696 6.29556C5.68704 5.87153 5.80368 5.45568 6.02414 5.09345C6.24458 4.73125 6.56034 4.4366 6.93698 4.24171C7.31356 4.04684 7.73655 3.95923 8.15952 3.98847C8.58256 4.01772 8.98944 4.16269 9.33564 4.40755C9.68178 4.65237 9.95402 4.98765 10.1225 5.37678C10.291 5.7659 10.3494 6.19394 10.2911 6.61391C10.2328 7.03384 10.0603 7.42979 9.79214 7.75838C9.52405 8.08691 9.17081 8.33539 8.7711 8.47671C8.72355 8.49356 8.68232 8.52478 8.6533 8.5658C8.6242 8.60703 8.60866 8.65613 8.6087 8.70635V9.27827C8.6087 9.61444 8.33617 9.88696 8 9.88696C7.66383 9.88696 7.3913 9.61444 7.3913 9.27827V8.70714C7.39119 8.40496 7.48488 8.10982 7.65916 7.86315C7.83362 7.61631 8.0804 7.42972 8.36523 7.32897C8.55462 7.26202 8.72196 7.1443 8.84892 6.98871C8.97586 6.83315 9.05762 6.6456 9.08524 6.44657C9.11285 6.24762 9.0852 6.04483 9.00537 5.86055C8.9256 5.67628 8.79666 5.51746 8.63266 5.40147C8.46869 5.2855 8.27595 5.21682 8.07555 5.20297Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M7.17826 11.1957C7.17826 10.7418 7.54617 10.3739 8 10.3739C8.45383 10.3739 8.82174 10.7418 8.82174 11.1957C8.82174 11.6495 8.45383 12.0174 8 12.0174C7.54617 12.0174 7.17826 11.6495 7.17826 11.1957Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8ZM8 2.21739C4.80636 2.21739 2.21739 4.80636 2.21739 8C2.21739 11.1936 4.80636 13.7826 8 13.7826C11.1936 13.7826 13.7826 11.1936 13.7826 8C13.7826 4.80636 11.1936 2.21739 8 2.21739Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
